module.exports = __webpack_public_path__ + "static/media/kaga-lose.ed529b98.png";